<template>
	<v-row v-if="loading" no-gutters justify="center" align="center" style="height: 600px">
		<v-progress-circular
			:size="50"
			color="primary"
			indeterminate
		></v-progress-circular>
	</v-row>
	<v-container v-else fluid>
		<v-row no-gutters>
			<v-btn
				small
				fab
				class="mb-3 mr-2"
				color="primary"
				@click="showCreateMonitoring = !showCreateMonitoring"
				:disabled="!$store.getters.hasAnyModule"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			<v-btn small fab class="mb-3 mr-2" color="primary" @click="showSendMonitoringEmail = true" :disabled="!$store.getters.hasAnyModule">
				<v-icon>mdi-email-edit-outline</v-icon>
			</v-btn>
			<SendMonitoringEmail :show="showSendMonitoringEmail" :patient="patient" @close="showSendMonitoringEmail = false"/>
			<v-btn small fab class="mb-3" color="primary" @click="showMonitoringLink = !showMonitoringLink" :disabled="!$store.getters.hasAnyModule">
				<v-icon>mdi-link-variant</v-icon>
			</v-btn>
			<v-text-field
				v-if="showMonitoringLink"
				v-model="monitoringLink"
				class="pl-2 text-caption"
				readonly
				outlined
				dense
				append-icon="mdi-content-copy"
				@click:append="copyLink"
				ref="monitoringLinkInput"
				hide-details
			/>
		</v-row>
		<v-row no-gutters v-if="!showCreateMonitoring" style="height: 25px">
			<v-snackbar class="text-caption" :timeout="1000" absolute right v-model="linkCopied">
				<translate>Copied</translate>
			</v-snackbar>
		</v-row>
		<v-row no-gutters v-if="showCreateMonitoring">
			<MonitoredSymptomForm
				ref="MSForm"
				:context="'patientMonitoring'"
				@monitored-symptom-created="mSCreated"
				:patientId="patient.id"
			/>
			<v-row no-gutters>
				<v-spacer></v-spacer>
				<v-btn color="primary" class="mr-6" @click="showCreateMonitoring = false">
					<translate key="cancel">Cancel</translate>
				</v-btn>
				<v-btn color="primary" class="mr-6" @click="createMonitoredSymptom">
					<translate key="create">Create</translate>
				</v-btn>
			</v-row>
		</v-row>
		<MonitoredSymptomList :monitoredSymptoms="monitoredSymptoms" />
	</v-container>
</template>

<script>
import MonitoredSymptomList from "@/components/patient/MonitoredSymptomList.vue";
import MonitoredSymptomForm from "@/components/patient/MonitoredSymptomForm.vue";
import SendMonitoringEmail from "@/components/patient/SendMonitoringEmail.vue";
import axios from "axios";

export default {
	name: "PatientMonitoring",
	props: ["patient"],
	components: {
		MonitoredSymptomList,
		MonitoredSymptomForm,
		SendMonitoringEmail
	},
	data: () => ({
		showCreateMonitoring: false,
		showMonitoringLink: false,
		showSendMonitoringEmail: false,
		linkCopied: false,
		monitoredSymptoms: [],
		loading: true
	}),
	computed: {
		monitoringLink() {
			return (
				"app.naltio.com/monitoring/" +
				this.patient.id +
				"?key=" +
				this.patient.monitoring_key
			);
		}
	},
	methods: {
		mSCreated(monitoredSymptom) {
			console.log("created");
			this.monitoredSymptoms.push(monitoredSymptom);
			this.showCreateMonitoring = false;
		},
		createMonitoredSymptom() {
			this.$refs.MSForm.createMonitoredSymptom();
		},
		copyLink() {
			let textToCopy = this.$refs.monitoringLinkInput.$el.querySelector(
				"input"
			);
			textToCopy.select();
			document.execCommand("copy");
			this.linkCopied = true;
		},
		deleteMonitoredSymptom(mS) {
			this.monitoredSymptoms.splice(this.monitoredSymptoms.indexOf(mS), 1);
		}
	},
	created() {
		axios
			.get("/patient/" + this.patient.id + "/monitored-symptoms")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.loading = false;
					this.monitoredSymptoms = response.data.monitored_symptoms;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>

<style scoped>
>>>.v-snack__wrapper {
    min-width: 1px;
}
>>>.v-snack__content {
    min-height: 1px;
    padding: 8px 16px;
    width: 100%;
}
</style>